import useLoginCheck from 'hooks/common/useLoginCheck';
import {
  getControllerList,
  getDashboardCounts,
  getStoreList,
} from 'lib/api/service/dashboard';
import { changeProp } from 'modules/serviceSlice';
import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';

const useServiceDashboard = () => {
  const dispatch = useDispatch();
  const { storeSearchWord, storeId } = useSelector(({ service }) => service);

  const getDashboardCountsQuery = useQuery(
    'serviceDashboardCounts',
    getDashboardCounts,
  );
  useLoginCheck(
    getDashboardCountsQuery.error?.response,
    getDashboardCountsQuery.refetch,
  );
  const dashboardCounts = getDashboardCountsQuery.data?.data;

  const getStoreListQuery = useQuery('storeList', getStoreList);
  useLoginCheck(getStoreListQuery.error?.response, getStoreListQuery.refetch);
  const storeList = getStoreListQuery.data?.data.list.filter(store =>
    store.store.includes(storeSearchWord),
  );

  const getStoreControllerListQuery = useQuery(
    ['storeControllerList', storeId],
    () => getControllerList(1, storeId),
  );
  useLoginCheck(
    getStoreControllerListQuery.error?.response,
    getStoreControllerListQuery.refetch,
  );
  const controllerList = getStoreControllerListQuery.data?.data;

  useEffect(() => {
    return () => {
      dispatch(changeProp({ key: 'storeSearchWord', value: '' }));
      dispatch(changeProp({ key: 'storeId', value: '' }));
    };
  }, [dispatch]);

  const onChange = e => {
    dispatch(changeProp({ key: 'storeSearchWord', value: e.target.value }));
  };

  return {
    storeSearchWord,
    getDashboardCountsQuery,
    dashboardCounts,
    getStoreListQuery,
    storeList,
    getStoreControllerListQuery,
    controllerList,
    onChange,
  };
};

export default useServiceDashboard;
